import {createAction} from 'redux-actions';

import * as types from './types';

export const setFocusRow = createAction(types.SET_FOCUS_ROW);
export const setEditRow = createAction(types.SET_EDIT_ROW);

export const setExpandedRows = createAction(types.SET_EXPANDED_ROWS);